import { render, staticRenderFns } from "./SelectExistingDocument.vue?vue&type=template&id=bf493788&"
import script from "./SelectExistingDocument.vue?vue&type=script&lang=ts&"
export * from "./SelectExistingDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports